import { useEffect } from "react";
import i18n, { applyStoredLanguage } from "@/lib/i18n";

export function I18nProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Apply the visitor's saved language AFTER first paint / hydration so
    // the SSR and initial client render agree (both use the default "bn").
    // This prevents the full-tree hydration mismatch that caused the flash
    // of blank frames on desktop.
    applyStoredLanguage();

    const syncHtmlLang = (l: string) => {
      if (typeof document !== "undefined") {
        document.documentElement.lang = l.startsWith("bn") ? "bn" : "en";
      }
    };
    syncHtmlLang(i18n.resolvedLanguage || i18n.language || "bn");
    i18n.on("languageChanged", syncHtmlLang);
    return () => { i18n.off("languageChanged", syncHtmlLang); };
  }, []);
  return <>{children}</>;
}
